export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    msg: '',
    rsvps: [],
    type: '',
    data: {
      notes: '',
      noteStatus: '',
      chargeFees: '',
      reason: '',
      refundAsCredits: '',
      cancelFee: ''
    }
  },
  mutations: {
    setCancelData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setData (state, data) {
      for (let field in data) {
        state.data[field] = data[field]
      }
    },
    updateRsvp (state, data) {
      let i = state.rsvps.findIndex(x => x.id === data.id)
      if (i > -1) {
        state.rsvps[i].cancellationFee = data.cancellationFee
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/cancel-upcoming.js